export default __webpack_public_path__ + "static/media/13-cn.7b0ea4f1.webp";